export default __webpack_public_path__ + "static/media/groupchaticon.b048a225.svg";